import Vue from 'vue'
import Vuex from 'vuex'
import idbs from '@/data/indexedDBService'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    activities: {
      active: {},
      inactive: {}
    },
    activityCheck: null,
    trackActivities: {
      dates: {},
      monthsTracked: [],
      activities: {}
    },
    counter: 0,
    key: null,
    activeDate: null,
    alert: {
      message: false,
      type: 'warning'
    },
    message: {
      message: false,
      position: 'bottom',
      onClose: false
    },
    dataLoading: {
      active: false
    },
    fullPageLoader: {
      active: false,
      message: 'Loading...'
    },
    user: {
      installInfo: {
        standAloneDate: null
      },
      isAdmin: 0
    },
    server: {
      status: true
    }
  },
  mutations: {
    setUserInfo (state, payload) {
      if (payload.isAdmin) {
        state.user.isAdmin = payload.isAdmin
      }
    },
    updateKey (state, payload) {
      state.key = payload.key
    },
    setActivities (state, payload) {
      if (payload.activities) {
        state.activities = payload.activities
      }
      state.activityCheck = true
    },
    addActivity (state, payload) {
      Vue.set(state.activities.active, payload.activity.id, payload.activity)
    },
    updateActivity (state, payload) {
      if (payload.id) {
        let activity = state.activities.active[payload.id]
        if (payload.title) {
          activity.title = payload.title
        }
        if (payload.newid) {
          activity.id = payload.newid
        }
        Vue.set(state.activities.active, payload.id, activity)
      }
    },
    deleteActivity (state, payload) {
      Vue.delete(state.activities.inactive, payload.id)
    },
    setMonthTracked (state, payload) {
      console.log('setting month tracked ' + payload.month)
      let months = state.trackActivities.monthsTracked
      if (!months.includes(payload.month)) {
        months.push(payload.month)
      }
      Vue.set(state.trackActivities, 'monthsTracked', months)
    },
    setTrackingDate (state, payload) {
      Vue.set(state.trackActivities.dates, payload.date, payload.activities)
    },
    addTrackingByActivity (state, payload) {
      if (!state.trackActivities.activities[payload.activity]) {
        Vue.set(state.trackActivities.activities, [payload.activity], [])
      }
      let activity = state.trackActivities.activities[payload.activity]
      // console.log(payload)
      if (!activity.includes(payload.date)) {
        activity.push(payload.date)
      }
      activity.sort()
      activity.reverse()
      Vue.set(state.trackActivities.activities, payload.activity, activity)
    },
    setActive (state, payload) {
      if (payload.active) {
        Vue.set(state.activities.active, payload.id, state.activities.inactive[payload.id])
        Vue.delete(state.activities.inactive, payload.id)
      } else {
        Vue.set(state.activities.inactive, payload.id, state.activities.active[payload.id])
        Vue.delete(state.activities.active, payload.id)
      }
    },
    toggleActivity (state, payload) {
      if (payload.obj.on) {
        // SET trackActivities by date
        if (!state.trackActivities.dates[payload.obj.date]) {
          state.trackActivities.dates[payload.obj.date] = []
        }
        let arr = state.trackActivities.dates[payload.obj.date]
        arr.push(payload.obj.id)
        Vue.set(state.trackActivities.dates, payload.obj.date, arr)

        // SET trackActivities by activity
        if (!state.trackActivities.activities[payload.obj.id]) {
          Vue.set(state.trackActivities.activities, [payload.obj.id], [])
        }
        let actArr = state.trackActivities.activities[payload.obj.id]
        if (!actArr.includes(payload.obj.date)) {
          actArr.push(payload.obj.date)
          actArr.sort()
          actArr.reverse()
          Vue.set(state.trackActivities.activities, [payload.obj.id], actArr)
        }
      } else {
        let arr = state.trackActivities.dates[payload.obj.date]
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === [payload.obj.id] * 1) {
            arr.splice(i, 1)
          }
        }

        // SET trackActivities by activity
        if (state.trackActivities.activities[payload.obj.id] && state.trackActivities.activities[payload.obj.id].includes(payload.obj.date)) {
          let actArr = state.trackActivities.activities[payload.obj.id]
          let i = actArr.indexOf(payload.obj.date)
          if (i !== -1) {
            actArr.splice(i, 1)
            actArr.sort()
            actArr.reverse()
          }
          Vue.set(state.trackActivities.activities, [payload.obj.id], actArr)
        }
      }
      Vue.set(state.trackActivities.dates, payload.obj.date, state.trackActivities.dates[payload.obj.date]
      )
      idbs.saveToStorage('trackActivities', {
        date: payload.obj.date,
        activities: state.trackActivities.dates[payload.obj.date] }
      )
    },
    setEmptyActivity (state, payload) {
      Vue.set(state.trackActivities.dates, payload.date, [])
    },
    removeTrackingDate (state, payload) {
      delete state.trackActivities[payload.date]
    },
    setDate (state, payload) {
      Vue.set(state, 'activeDate', payload.value)
    },
    setAlert (state, payload) {
      Vue.set(state.alert, 'message', payload.message)
      if (payload.type) {
        Vue.set(state.alert, 'type', payload.type)
      }
    },
    setMessage (state, payload) {
      Vue.set(state.message, 'message', payload.message)
      if (payload.position) {
        Vue.set(state.message, 'position', payload.position)
      }
      if (payload.onClose) {
        Vue.set(state.message, 'onClose', payload.onClose)
      }
    },
    resetMessage (state, payload) {
      Vue.set(state, 'message', {
        message: false,
        position: 'bottom',
        onClose: false
      })
    },
    setStandaloneDate (state, payload) {
      Vue.set(state.user.installInfo, 'standAloneDate', payload.timestamp)
    },
    setFullPageLoader (state, payload) {
      Vue.set(state.fullPageLoader, 'active', payload.active)
      if (payload.message) {
        Vue.set(state.fullPageLoader, 'message', payload.message)
      }
    },
    setDataLoading (state, payload) {
      Vue.set(state.dataLoading, 'active', payload.active)
      if (payload.message) {
        Vue.set(state.fullPageLoader, 'message', payload.message)
      }
    },
    serverStatus (state, payload) {
      Vue.set(state.server, 'status', payload.status)
    },
    emptyStore (state, payload) {
      state.key = null
      state.activities = {
        active: {},
        inactive: {}
      }
      state.trackActivities = {
        dates: {},
        monthsTracked: [],
        activities: {}
      }
      state.activityCheck = null
      state.activeDate = null
      state.alert = {
        message: false,
        type: 'warning'
      }
      state.message = {
        message: false,
        position: 'bottom',
        onClose: false
      }
      state.fullPageLoader = {
        active: false
      }
      state.dataLoading = {
        active: false
      }
      state.user = {
        installInfo: {
          standAloneDate: null
        },
        isAdmin: 0
      }
      state.server = {
        status: true
      }
    }

  }
})



// WEBPACK FOOTER //
// ./src/store.js